import React, { FC } from 'react';

const FileNameUsername: FC<any> = (properties: {
    row: {
        original: {
            fileTypeName: string | null;
            createdBy: string | null;
            fileTypeId: string | null;
            transactionType: string | null;
            isProtoParsingSupported?: boolean | null;
        };
    };
}) => {
    const {
        row: {
            original: { fileTypeName, createdBy, transactionType, isProtoParsingSupported },
        },
    } = properties;

    if (isProtoParsingSupported === true && transactionType === "DATAFILE") {
        return <>N/A</>;
    }
    if (createdBy && fileTypeName) {
        if (createdBy === fileTypeName) {
            return (<>{fileTypeName || 'N/A'}</>);
        }
        return (<>{fileTypeName} / {createdBy}</>);
    }
    return (<>{fileTypeName || 'N/A'}</>);
};

export default FileNameUsername;
